import React from 'react';

interface ErrorBoundaryProps {
  children?: React.ReactNode;
  errorPlug?: string;
  ErrorPage?: any;
  reportFunc?: (value: { message: string; stack: string }) => void;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { reportFunc } = this.props;
    if (reportFunc) {
      reportFunc({ message: error.message, stack: errorInfo.componentStack });
    }
  }

  render() {
    const {
      children,
      errorPlug = 'Something went wrong',
      ErrorPage,
    } = this.props;

    const { hasError } = this.state;

    if (hasError) {
      return ErrorPage ? <ErrorPage /> : errorPlug;
    }

    return children;
  }
}

export default ErrorBoundary;
